import './validation.scss';
import React from "react";
import { ValidationRequirement } from "../../../entities/forms/Validation"
import { ErrorIcon } from "../../icons";

type Props = {
    validationResults: ValidationRequirement[];
}

export const ValidationResultsComponent = (props: Props) => {
    const { validationResults } = props;
    return (
        <div className="validation-results">
            {validationResults.filter(vr => vr.match).unique(vr => vr.message).map(vr => (
                <div key={vr.message} className="validation-result">
                    <ErrorIcon />&nbsp;{vr.message}
                </div>
            ))}
        </div>
    );
}